import cx from 'classnames'
import PropTypes from 'prop-types'
import styles from './index.css'
import SpecListArrayField from './SpecListArrayField'

const SpecInfo = props => {
  const {
    className,
    readOnly,
    syncTransientAttributes,
    mustShowFormError,
    showErrorOnActive
  } = props

  return (
    <div
      className={cx(styles.SpecInfo, className)}
      data-role='spec-info'
    >
      <SpecListArrayField
        readOnly={readOnly}
        syncTransientAttributes={syncTransientAttributes}
        mustShowFormError={mustShowFormError}
        showErrorOnActive={showErrorOnActive}
      />
    </div>
  )
}

SpecInfo.propTypes = {
  triggerFieldChange: PropTypes.func.isRequired
}

export default SpecInfo
